import { api } from "@/api";

export const deleteBettingSelectionMapping = async (
  selectionId: number,
  id: number
): Promise<void> => {
  await api.client.delete(`/betting-selections-new/${selectionId}/mappings/${id}`);
};
